import { ToastContainer, toast } from 'react-toastify';

const NOTIFICATION_DELAY_MS = 3000;

export function errorNotification(errorType: string, errorMessage: string) {
  toast.error(errorType + ' - ' + errorMessage, {
    autoClose: NOTIFICATION_DELAY_MS,
    pauseOnHover: true,
    theme: 'colored',
  });
}

export function warningNotification(message: string) {
  toast.warning(message, {
    autoClose: NOTIFICATION_DELAY_MS,
    pauseOnHover: true,
    theme: 'colored',
  });
}

export function infoNotification(message: string) {
  toast.info(message, {
    autoClose: NOTIFICATION_DELAY_MS,
    pauseOnHover: true,
    theme: 'colored',
  });
}

export const NotificationContainer = () => {
  return <ToastContainer />;
};
